module.exports = __webpack_public_path__ + "static/media/gif.c0fa1f52.gif";